/**
 * Profile scripts
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';


injector.injectClass(class extends Script {
    onLoad() {
        $('#coupon_form').each(this.$wrap(this.initForm));
    }

    initForm($form) {
        const $error = $('#error');
        const $success = $('#success');

        $form.on('submit', () => {
            const invoice = $form.find('[name=invoice]').val();
            const coupon = $form.find('[name=coupon]').val();

            $form.find(':input,button').prop('disabled', true);
            $error.hide();
            $success.hide();

            $.ajax({
                type: 'POST',
                url: $form.attr('action'),
                data: { invoice, coupon },
            }).done((response) => {
                if (response.includes('Educational')) {
                    const $select = $form.find('[name=invoice]');
                    const $option = $select.find('option:selected');
                    const pid = $option.data('pid');

                    $('#edu_product').val(pid);
                    $('#edu_coupon').val(coupon);
                    $('#edu_form').trigger('submit');
                } else if (response.includes('error')) {
                    $error.show();
                    const $li = $('<li>').append(response);
                    $error.find('ul').empty().append($li);
                } else {
                    $form.hide();
                    $success.show();
                }
            }).always(() => {
                $form.find(':input,button').prop('disabled', false);
            });

            return false;
        });
    }
}, ['coupon']);
